import { AutoMap } from "@automapper/classes";


export class SecuriteDTO {
    @AutoMap()
    entreeZone!: number;
    @AutoMap()
    dureeExposition!: number;
    @AutoMap()
    epi!: number;
    @AutoMap()
    moyenObservation!: number;
}